import React from 'react';
import ApexChart from "react-apexcharts";
import dayjs from 'dayjs';

const DonutChart = (props: { series: number[], score?: number }) => {
    const options = {
      dataLabels: { enabled: false },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: false
            }
          }
        }
      },
      labels: ['Time lost', 'Time saved'],
      colors: ['var(--color-red)', 'var(--color-green)'],
      legend: { show: false },
    };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: 400,
        margin: "0 auto",
      }}
    >
      <ApexChart
        height={160}
        options={options}
        series={props.series}
        type="donut"
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
        }}
      >
        <span
          style={{
            fontSize: "24px",
            fontWeight: 400,
            color: typeof(props.score) !== "undefined" && props.score < 1 ? "var(--color-red)" : "var(--color-green)",
            textAlign: "center",
          }}
        >
          {props.score ?? ""}
        </span>
      </div>
    </div>
  );
};

export default DonutChart;